import './index.css';
import { useTranslation } from 'react-i18next';
import FoodFilterElement from '../foodFilterElement';
import { FoodFilter as FoodFilterI } from '../../../../api-types/models/UserDto';
import { ReactNode, useCallback, useEffect, useState } from 'react';
import { useUpdateFoodFilterMutation } from '../../../../api/userApi';

interface IProps {
    foodFilter: FoodFilterI;
}

export function FoodFilter({ foodFilter }: Readonly<IProps>): ReactNode {
    const { t } = useTranslation();
    const [updateFoodFilter] = useUpdateFoodFilterMutation();
    const [filter, setFilter] = useState(foodFilter);

    useEffect(() => {
        setFilter(foodFilter);
    }, [foodFilter]);

    const handleUpdateFoodFilter = useCallback(
        (food: keyof FoodFilterI) => {
            const value = !filter[food];
            setFilter({ ...filter, [food]: value });
            updateFoodFilter({ filter: food, value });
        },
        [filter, updateFoodFilter]
    );

    return (
        <div className='food-filter-options box'>
            <div className='options-title'>{t('food_filter')}</div>
            <div className='options-text'>{t('food_filter_helper')}</div>
            <div className='food-filter'>
                {Object.keys(filter).map((food) => {
                    const foodKey = food as keyof FoodFilterI;
                    return (
                        <div
                            key={food}
                            className='food-filter-element'
                            onClick={() => handleUpdateFoodFilter(foodKey)}
                        >
                            <FoodFilterElement
                                foodName={food}
                                enabled={filter[foodKey]}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
